$(document).ready(function(){
    $('.design-slider').length > 0 && $('.design-slider').slick({
      slidesToShow: 3,         
      slidesToScroll: 1,         
      autoplay: true,            
      autoplaySpeed: 2000,      
      dots:false, 
      centerMode: true,             
      responsive: [
        {
          breakpoint: 1024,      
          settings: {
            slidesToShow: 3,   
            slidesToScroll: 1,   
          }
        },
        {
          breakpoint: 768,       
          settings: {
            slidesToShow:3,  
            slidesToScroll: 1,  
          }
        },
        {
          breakpoint: 480,       
          settings: {
            slidesToShow: 1,     
            slidesToScroll: 1,   
          }
        }
      ]
    });
  });



  $(document).ready(function(){
    $('.image-banner-slider').length > 0 && $('.image-banner-slider').slick({
      slidesToShow: 1,         
      slidesToScroll: 1,         
      autoplay: true,            
      autoplaySpeed: 2000,      
      dots:true, 
      centerMode: true, 
      arrows: false             
    });
  });